export default {
      id: "ic_hashtag-usage",
      viewBox: "0 0 239 262",
      url: "../dist/images/" + "sprite.svg#ic_hashtag-usage",
      toString: function () {
        return this.url;
      }
    }